import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

import {
  isPendingAction,
  isRejectedAction,
  isFulfilledAction
} from '../actions';

const name = 'localizations';

export const getLocales = createAsyncThunk(`${name}/getLocales`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get('/api/localizations');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getLocalizations = createAsyncThunk(`${name}/getLocalizations`,
  async (lang, { rejectWithValue }) => {
    try {
      const locale = lang || localStorage.getItem('lang') || 'fi';
      const response = await axios.get(`/api/localizations/${locale}`);
      return {
        locale,
        localizations: response.data
      };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const localizationSlice = createSlice({
  name,
  initialState: {
    loading: false,
    errors: false,
    locale: null,
    options: [],
    messages: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLocales.fulfilled, (state, action) => {
        state.options = action.payload;
      })
      .addCase(getLocalizations.fulfilled, (state, action) => {
        const { locale, localizations } = action.payload;
        localStorage.setItem('lang', locale);
        state.locale = locale;
        state.messages = localizations;
      })
      .addMatcher(isPendingAction(name), (state) => {
        state.loading = true;
        state.errors = false;
      })
      .addMatcher(isRejectedAction(name), (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addMatcher(isFulfilledAction(name), (state) => {
        state.loading = false;
      })
  }
});

export default localizationSlice.reducer;